import { acceptHMRUpdate, defineStore } from 'pinia'
import { getCustomerList } from '../scripts/customers'

export const useCustomers = defineStore('customers', {
    state: () => ({
        customers: [],
        loading: true,
        selectedCustomers: []
    }),
    actions: {
        async getCustomers() {
            this.loading = true

            try {
                const list = await getCustomerList()
                if (list && list.length > 0) {
                    this.customers = list
                    if (this.customers.length === 1) {
                        this.selectedCustomers = this.customers
                    }
                } else {
                    this.customers = []
                    this.selectedCustomers = []
                }

                // Empty list is a valid result (e.g. demo before org setup), not a fetch failure
                return true
            } catch (error) {
                console.error(error)
                this.customers = []
                this.selectedCustomers = []
                return false
            } finally {
                this.loading = false
            }
        }
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCustomers, import.meta.hot))
}
